<script lang="ts" setup>
import { computed, defineProps } from "vue";
import { AlertMessageType } from "@/constants/components";

const props = withDefaults(
  defineProps<{
    bgColor?: string;
    borderColor?: string;
    color?: string;
    icon?: string;
    iconColor?: string;
    padding?: string;
    align?: "top" | "center" | "bottom";
    iconClass?: string;
    type?: AlertMessageType;
    contentClass?: string;
  }>(),
  {
    bgColor: "amber-lighten-5",
    borderColor: "warning",
    color: "grey-darken-3",
    icon: "mdi-alert-circle-outline",
    iconColor: "warning",
    padding: "pa-2",
    align: "center",
    iconClass: "",
    type: undefined,
    contentClass: "",
  },
);

const alertClass = computed(() => {
  if (!props.type) {
    return [
      `bg-${props.bgColor}`,
      `border-${props.borderColor}`,
      `text-${props.color}`,
      `align-${props.align}`,
      `${props.padding}`,
    ];
  }

  switch (props.type) {
    case AlertMessageType.warning:
      return ["bg-amber-lighten-5", "border-warning", props.padding];
    case AlertMessageType.danger:
      return ["bg-red-lighten-5", "border-danger", props.padding];
    default:
      return [];
  }
});

const iconColor = computed(() => {
  if (!props.type) {
    return props.iconColor;
  }

  switch (props.type) {
    case AlertMessageType.warning:
      return "warning";
    case AlertMessageType.danger:
      return "danger";
    default:
      return "indigo";
  }
});
</script>

<template>
  <div :class="alertClass" class="rounded d-flex font-size-12 font-weight-500">
    <v-icon :class="props.iconClass" :color="iconColor" :icon="props.icon" size="20"></v-icon>
    <div :class="contentClass" class="ml-2" data-qa="update-message">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
